import { rest } from 'msw'
import moment from 'moment'
moment.locale('ja')
export default [
  /**
   * チラシ一覧情報
   */
  rest.post('/api/v2/get_flyer_list', (req, res, ctx) => {
    // Persist user's authentication in the session
    const shopId = req.body.shopId || req.body.shopCode
    const filterId =
      shopId === 3 || shopId === 4
        ? shopId
        : shopId > 2 || shopId < 1
        ? 1
        : shopId
    const data = [
      {
        id: 1,
        detailId: 1,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '7月28日号',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            thumb_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            pc_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            sp_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
          {
            seq: 3,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            thumb_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 1459,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            pc_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            pc_image_height: 2040,
            pc_image_width: 1459,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            sp_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            sp_image_height: 2040,
            sp_image_width: 1459,
          },
          {
            seq: 4,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            thumb_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 1459,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            pc_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            pc_image_height: 2040,
            pc_image_width: 1459,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            sp_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            sp_image_height: 2040,
            sp_image_width: 1459,
          },
        ],
      },
      {
        id: 2,
        detailId: 2,
        detailShopId: 2,
        detailShopName: 'テスト',
        title: '表示確認用チラシ2',
        openDate: '1593529200',
        closeDate: '1604070000',
        imageCount: 2,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063001_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            sp_image: '/assets/flyers/7/202007/063001_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            pc_image: '/assets/flyers/7/202007/063001_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063002_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            sp_image: '/assets/flyers/7/202007/063002_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            pc_image: '/assets/flyers/7/202007/063002_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
        ],
      },
      {
        id: 3,
        detailId: 3,
        detailShopId: 3,
        detailShopName: 'テスト',
        title: '表示確認用チラシ3',
        openDate: '1593529200',
        closeDate: '1604070000',
        imageCount: 2,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063001_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            sp_image: '/assets/flyers/7/202007/063001_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            pc_image: '/assets/flyers/7/202007/063001_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063002_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            sp_image: '/assets/flyers/7/202007/063002_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            pc_image: '/assets/flyers/7/202007/063002_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
        ],
      },
      {
        id: 4,
        detailId: 4,
        detailShopId: 4,
        detailShopName: 'テスト',
        title: '表示確認用チラシ4',
        openDate: '1593529200',
        closeDate: '1604070000',
        imageCount: 2,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063001_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            sp_image: '/assets/flyers/7/202007/063001_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            pc_image: '/assets/flyers/7/202007/063001_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063002_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            sp_image: '/assets/flyers/7/202007/063002_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            pc_image: '/assets/flyers/7/202007/063002_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
        ],
      },
    ]
    const data2 = [
      {
        id: 1,
        detailId: 1,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '12月01日号',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            thumb_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            pc_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            sp_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
          {
            seq: 3,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            thumb_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 1459,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            pc_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            pc_image_height: 2040,
            pc_image_width: 1459,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            sp_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
            sp_image_height: 2040,
            sp_image_width: 1459,
          },
          {
            seq: 4,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            thumb_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 1459,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            pc_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            pc_image_height: 2040,
            pc_image_width: 1459,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            sp_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
            sp_image_height: 2040,
            sp_image_width: 1459,
          },
        ],
      },
      {
        id: 2,
        detailId: 2,
        detailShopId: 2,
        detailShopName: 'テスト',
        title: '12月02日号',
        openDate: '1593529200',
        closeDate: '1604070000',
        imageCount: 2,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063001_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            sp_image: '/assets/flyers/7/202007/063001_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            pc_image: '/assets/flyers/7/202007/063001_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063002_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            sp_image: '/assets/flyers/7/202007/063002_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            pc_image: '/assets/flyers/7/202007/063002_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
        ],
      },
      {
        id: 3,
        detailId: 3,
        detailShopId: 3,
        detailShopName: 'テスト',
        title: '12月03日号',
        openDate: '1593529200',
        closeDate: '1604070000',
        imageCount: 2,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063001_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            sp_image: '/assets/flyers/7/202007/063001_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            pc_image: '/assets/flyers/7/202007/063001_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063002_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            sp_image: '/assets/flyers/7/202007/063002_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            pc_image: '/assets/flyers/7/202007/063002_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
        ],
      },
      {
        id: 4,
        detailId: 4,
        detailShopId: 4,
        detailShopName: 'テスト',
        title: '12月04日号',
        openDate: '1593529200',
        closeDate: '1604070000',
        imageCount: 2,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063001_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            sp_image: '/assets/flyers/7/202007/063001_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063001_07.jpg',
            pc_image: '/assets/flyers/7/202007/063001_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
          {
            seq: 2,
            thumb_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            thumb_image: '/assets/flyers/7/202007/063002_07.jpg',
            thumb_image_height: 775,
            thumb_image_width: 1107,
            sp_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            sp_image: '/assets/flyers/7/202007/063002_07.jpg',
            sp_image_height: 775,
            sp_image_width: 1107,
            pc_image_url:
              'https://static-stg.retailstudio.jp/assets/flyers/7/202007/063002_07.jpg',
            pc_image: '/assets/flyers/7/202007/063002_07.jpg',
            pc_image_height: 775,
            pc_image_width: 1107,
          },
        ],
      },
    ]
    /**
     * ダイエー用
     */
    const data3 = [
      {
        id: 1,
        detailId: 1,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '6/1（水）号チラシ',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 2,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '5/31（火）号チラシ',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 3,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '5/30（月）号チラシ',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 4,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '5/28（土）号チラシ',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 5,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '5/28（土）号チラシ',
        openDate: '1497935600',
        closeDate: '1501478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 6,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '5/29（日）号チラシ',
        openDate: '1497935600',
        closeDate: '1501478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/o=true/4955661.jpg?1653977725',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 7,
        detailShopId: 1,
        detailShopName: 'テスト',
        title: '5/29（日）号チラシ',
        openDate: '1597935600',
        closeDate: '1601478000',
        imageCount: 4,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=144,h=144,mc=true,wo=0,ho=0,cw=144,ch=144,aw=144/4951234.jpg?1653642424',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
    ]
    const data4 = [
      {
        id: 1,
        detailId: 1,
        detailShopId: 4,
        detailShopName: 'テスト',
        title: '5/20号「お酢ってすごい！酢」表',
        openDate: '1652972400',
        closeDate: '1653145200',
        imageCount: 1,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=130,h=150/4925296.jpg?1652774926',
            thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=130,h=150/4925296.jpg?1652774926',
            pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=130,h=150/4925296.jpg?1652774926',
            sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 2,
        detailId: 2,
        detailShopId: 4,
        detailShopName: 'テスト',
        title: '5/20号　裏面',
        openDate: '1652972400',
        closeDate: '1653231600',
        imageCount: 1,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=200,h=150/4925297.jpg?1652774962',
            thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=200,h=150/4925297.jpg?1652774962',
            pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=200,h=150/4925297.jpg?1652774962',
            sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
      {
        id: 1,
        detailId: 1,
        detailShopId: 4,
        detailShopName: 'テスト',
        title: '5/20号「お酢ってすごい！酢」表',
        openDate: '1652972400',
        closeDate: '1653145200',
        imageCount: 1,
        images: [
          {
            seq: 1,
            thumb_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=130,h=150/4925296.jpg?1652774926',
            thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            thumb_image_height: 2040,
            thumb_image_width: 2918,
            pc_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=130,h=150/4925296.jpg?1652774926',
            pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            pc_image_height: 2040,
            pc_image_width: 2918,
            sp_image_url:
              'https://image.tokubai.co.jp/images/bargain_office_leaflets/w=130,h=150/4925296.jpg?1652774926',
            sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
            sp_image_height: 2040,
            sp_image_width: 2918,
          },
        ],
      },
    ]
    // console.log(data)
    const items =
      filterId === 4
        ? data4
        : filterId === 3
        ? data3
        : filterId > 1
        ? data2
        : data
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: {
          items,
          shopName: 'ウエストランド店2',
          count: 4,
          responseTime: 1599199141,
        },
      })
    )
  }),
  /**
   * チラシ詳細情報
   */
  rest.post('/api/v2/get_flyer_detail', (req, res, ctx) => {
    // Persist user's authentication in the session
    const chirasiId = req.body.id
    const filterId = chirasiId % 2 === 0 ? 2 : 1
    const data1 = {
      id: 1,
      detailId: 1,
      title: '7月28日号',
      openDate: '1597935600',
      closeDate: '1601478000',
      imageCount: 4,
      shopName: '大崎店',
      images: [
        {
          seq: 1,
          thumb_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          thumb_image_height: 2040,
          thumb_image_width: 2918,
          pc_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          pc_image_height: 2040,
          pc_image_width: 2918,
          sp_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          sp_image_height: 2040,
          sp_image_width: 2918,
        },
      ],
      advertisements: [
        {
          id: 1,
          type: 0,
          title: 'テスト広告',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          maker: 'テストメーカー',
        },
      ],
      productGroups: [
        {
          id: 1,
          title: '関連商品テーマタイトル',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          periodStart: moment().add(-1, 'days').unix(),
          periodEnd: moment().add(1, 'days').unix(),
          products: [
            {
              jan: '4999991',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: '',
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999992',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999993',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-3, 'days').unix(),
              periodEnd: moment().add(5, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999994',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(0, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999995',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
          ],
        },
      ],
      responseTime: 1599136738,
    }
    const data2 = {
      id: 4,
      detailId: 3,
      title: '7月28日号',
      openDate: '1597935600',
      closeDate: '1601478000',
      imageCount: 4,
      shopName: '大崎店',
      images: [
        {
          seq: 1,
          thumb_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          thumb_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          thumb_image_height: 2040,
          thumb_image_width: 2918,
          pc_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          pc_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          pc_image_height: 2040,
          pc_image_width: 2918,
          sp_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          sp_image: 'assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          sp_image_height: 2040,
          sp_image_width: 2918,
        },
        {
          seq: 2,
          thumb_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
          thumb_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
          thumb_image_height: 2040,
          thumb_image_width: 2918,
          pc_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
          pc_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
          pc_image_height: 2040,
          pc_image_width: 2918,
          sp_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
          sp_image: 'assets/flyers/4/53fa1f087bed7a49eb2f50fff07f97cc.jpg',
          sp_image_height: 2040,
          sp_image_width: 2918,
        },
        {
          seq: '3',
          thumb_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
          thumb_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
          thumb_image_height: 2040,
          thumb_image_width: 1459,
          pc_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
          pc_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
          pc_image_height: 2040,
          pc_image_width: 1459,
          sp_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
          sp_image: 'assets/flyers/4/bcaf80b0e2e527a3618050c68e776dfe.jpg',
          sp_image_height: 2040,
          sp_image_width: 1459,
        },
        {
          seq: '4',
          thumb_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
          thumb_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
          thumb_image_height: 2040,
          thumb_image_width: 1459,
          pc_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
          pc_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
          pc_image_height: 2040,
          pc_image_width: 1459,
          sp_image_url:
            'https://static-stg.retailstudio.jp/assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
          sp_image: 'assets/flyers/4/b8deba113bfca4e266c5d4cb11831c59.jpg',
          sp_image_height: 2040,
          sp_image_width: 1459,
        },
      ],
      advertisements: [
        {
          id: 1,
          type: 0,
          title: 'テスト広告',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          maker: 'テストメーカー',
        },
        {
          id: 2,
          type: 0,
          title: 'テスト広告',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          maker: 'テストメーカー',
        },
        {
          id: 3,
          type: 0,
          title: 'テスト広告',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          maker: 'テストメーカー',
        },
      ],
      productGroups: [
        {
          id: 1,
          title: '関連商品テーマタイトル',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          periodStart: moment().add(-1, 'days').unix(),
          periodEnd: moment().add(1, 'days').unix(),
          products: [
            {
              jan: '4999991',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: '',
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999992',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999993',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-3, 'days').unix(),
              periodEnd: moment().add(5, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999994',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(0, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999995',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
          ],
        },
        {
          id: 2,
          title: '関連商品テーマタイトル',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          periodStart: moment().add(-1, 'days').unix(),
          periodEnd: moment().add(1, 'days').unix(),
          products: [
            {
              jan: '4999996',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: '',
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999997',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999998',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-3, 'days').unix(),
              periodEnd: moment().add(5, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999999',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(0, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999910',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
          ],
        },
        {
          id: 3,
          title: '関連商品テーマタイトル',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          periodStart: moment().add(-1, 'days').unix(),
          periodEnd: moment().add(1, 'days').unix(),
          products: [
            {
              jan: '4999911',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: '',
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999912',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999913',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-3, 'days').unix(),
              periodEnd: moment().add(5, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999914',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(0, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999915',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
          ],
        },
        {
          id: 4,
          title: '関連商品テーマタイトル',
          image:
            'https://static-stg.retailstudio.jp/assets/flyers/4/ec97c0957ea69ead10145f9edf94cc1e.jpg',
          periodStart: moment().add(-1, 'days').unix(),
          periodEnd: moment().add(1, 'days').unix(),
          products: [
            {
              jan: '4999916',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: '',
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999917',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999918',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-3, 'days').unix(),
              periodEnd: moment().add(5, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999919',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(0, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
            {
              jan: '4999929',
              name: 'エビピラフ',
              image: 'https://placehold.jp/150x150.png',
              price: 128,
              priceSub: 138.25,
              periodStart: moment().add(-1, 'days').unix(),
              periodEnd: moment().add(1, 'days').unix(),
              remark: '+30P',
              score: null,
              stock: null,
            },
          ],
        },
      ],
      responseTime: 1599136738,
    }
    const data = filterId > 1 ? data2 : data1
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data,
      })
    )
  }),
  /**
   * チラシ商品グループ詳細取得
   */
  rest.post('/api/v2/get_flyer_products_detail', (req, res, ctx) => {
    const data = [
      {
        id: 1,
        title: 'これはテスト',
        type: 0,
        image: 'https://placehold.jp/150x150.png',
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        maker: '味の素',
        details: [
          {
            seq: 2,
            type: 'title',
            background: '#9f9cda',
            color: '#5a4646',
            body: 'サブタイトル',
            attribute: [],
          },
          {
            seq: 1,
            type: 'text',
            background: '#bef4c8',
            color: '',
            body:
              '<p>本文テスト  <b>ここは太字 <font color="#de4a4a">ここは太字＋赤字</font></b></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/920" target="_blank">リンクが入ります。</a></p><p><br></p>',
            attribute: [],
          },
          {
            seq: 3,
            type: 'image',
            background: '#fe7878',
            color: '',
            body:
              'https://static-stg.retailstudio.jp/assets/contents/910/detail_675be3d77fcf592f0ff324e76d2739be.png',
            attribute: {
              height: '199',
              width: '289',
            },
            url: 'https://mypage-stg.retailstudio.jp/maruilife/11/content',
          },
          {
            seq: 5,
            type: 'quote',
            background: '#fffdd5',
            color: '',
            body:
              '<p>引用テキストです。</p><p><b>ここは太字</b></p><p><font color="#1da6e3">ここは青字</font></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/906" target="_blank">ここがリンク</a></p><p>ノーマルテキスト</p>',
            attribute: [],
          },
          {
            seq: 4,
            type: 'image',
            background: '#fe7878',
            color: '',
            body:
              'https://static-stg.retailstudio.jp/assets/contents/910/detail_675be3d77fcf592f0ff324e76d2739be.png',
            attribute: {
              height: '199',
              width: '289',
            },
            url: 'https://mypage-stg.retailstudio.jp/maruilife/11/content',
          },
          {
            seq: 6,
            type: 'quote',
            background: '#fffdd5',
            color: '',
            body:
              '<p>引用テキストです。</p><p><b>ここは太字</b></p><p><font color="#1da6e3">ここは青字</font></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/906" target="_blank">ここがリンク</a></p><p>ノーマルテキスト</p>',
            attribute: [],
          },
          {
            seq: 9,
            type: 'text',
            background: '#bef4c8',
            color: '',
            body:
              '<p>本文テスト  <b>ここは太字 <font color="#de4a4a">ここは太字＋赤字</font></b></p><p><a href="https://mypage-stg.retailstudio.jp/maruilife/11/content/920" target="_blank">リンクが入ります。</a></p><p><br></p>',
            attribute: [],
          },
          {
            seq: 7,
            type: 'caption',
            background: '#38f000',
            body: 'キャプションテスト',
            attribute: [],
          },
          {
            seq: 8,
            type: 'embedded',
            background: '#eca8de',
            body: 'https://www.youtube.com/watch?v=PRf02Vgcdgw',
            attribute: {
              title:
                '【ハッキリ言って無限です】ミシュランシェフが教える最高に簡単でおいしい神レシピ「無限ペペたま」フルVerはクラシルアプリで先行公開中！【鳥羽周作の◯◯な料理 vol.25 #おうちでsio】クラシル',
              author_name: 'kurashiru [クラシル]',
              author_url: 'https://www.youtube.com/c/kurashiru',
              type: 'video',
              height: 113,
              width: 200,
              version: '1.0',
              provider_name: 'YouTube',
              provider_url: 'https://www.youtube.com/',
              thumbnail_height: 360,
              thumbnail_width: 480,
              thumbnail_url: 'https://i.ytimg.com/vi/PRf02Vgcdgw/hqdefault.jpg',
              html:
                '<iframe width="200" height="113" src="https://www.youtube.com/embed/PRf02Vgcdgw?feature=oembed" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>',
            },
          },
        ],
        products: [
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: '',
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-3, 'days').unix(),
            periodEnd: moment().add(5, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(0, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
        ],
      },
      {
        id: 2,
        title: 'これはテスト2',
        type: 0,
        image: 'https://placehold.jp/150x150.png',
        periodStart: moment().add(-1, 'days').unix(),
        periodEnd: moment().add(-1, 'days').unix(),
        maker: '味の素',
        details: [],
        products: [
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(-1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(-1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(-1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(-1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
          {
            shopName: '大崎駅前店',
            jan: '4999999999999',
            name: 'エビピラフ',
            image: 'https://placehold.jp/150x150.png',
            price: 128,
            priceSub: 138.25,
            periodStart: moment().add(-1, 'days').unix(),
            periodEnd: moment().add(-1, 'days').unix(),
            remark: '+30P',
            score: null,
            stock: null,
          },
        ],
      },
    ]
    const id = req.body.id
    const filter = data.filter(item => item.id === id)
    const result = 0 in filter ? filter[0] : data[0]
    return res(
      ctx.status(200),
      ctx.json({
        error: {
          errorCode: 0,
          errorMessage: '',
          errorMessageDetail: '',
        },
        data: result,
      })
    )
  }),
]
